module.exports = __webpack_public_path__ + "img/card2.png?962add613e83bb2ab6cbbb9e359b687a";